var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { oneOf, bool, number } from 'prop-types';
import { system } from '@gympass/yoga-system';
import textStyle from '../textStyle.web';
import { deprecated } from '../../shared';

var styledText = function styledText(type, element) {
  if (element === void 0) {
    element = false;
  }

  return (element ? styled[type] : styled.p)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  padding: 0;\n\n  ", "\n  ", "\n"])), textStyle(type), system);
};

var H1 = styledText('h1', true);
H1.displayName = 'Text.H1';
var H2 = styledText('h2', true);
H2.displayName = 'Text.H2';
var H3 = styledText('h3', true);
H3.displayName = 'Text.H3';
var H4 = styledText('h4', true);
H4.displayName = 'Text.H4';
var H5 = styledText('h5', true);
H5.displayName = 'Text.H5';
var Small = styledText('small');
Small.displayName = 'Text.Small';
var Tiny = styledText('tiny');
Tiny.displayName = 'Text.Tiny';
var Light = styledText('light');
Light.displayName = 'Text.Light';
var Regular = styledText('regular');
Regular.displayName = 'Text.Regular';
var Medium = styledText('medium');
Medium.displayName = 'Text.Medium';
var Bold = styledText('bold');
Bold.displayName = 'Text.Bold';
var Black = styledText('black');
Black.displayName = 'Text.Black';
var SectionTitle = styledText('sectionTitle');
SectionTitle.displayName = 'Text.SectionTitle';
var SmallestException = styledText('smallestException');
SmallestException.displayName = 'Text.SmallestException';
var TextRenderer = styledText('p');

var Text = function Text(props) {
  return /*#__PURE__*/React.createElement(TextRenderer, props);
};

Text.displayName = 'Text';
Text.propTypes = {
  inverted: bool,
  numberOfLines: number,

  /** (deprecated: use color instead) style the text following the theme */
  variant: deprecated(oneOf(['primary', 'secondary', 'vibin', 'hope', 'energy', 'relax', 'peace', 'verve', 'uplift', 'deepPurple', 'stamina', 'deep', 'medium', 'light', 'clear', 'white']), 'Use `color` system prop instead'),

  /** set the font-size following the theme */
  size: oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge', 'huge']),

  /** set the font-weight to regular */
  light: bool
};
Text.defaultProps = {
  inverted: false,
  variant: undefined,
  size: 'medium',
  numberOfLines: undefined,
  light: false
};
export { TextRenderer, Text, H1, H2, H3, H4, H5, Small, Tiny, Light, Regular, Medium, Bold, Black, SectionTitle, SmallestException };